/** Inspector progress digest triggers (must match backend inspectorReportSummaryEmailTriggers.cjs). */

export const INSPECTOR_REPORT_SUMMARY_EMAIL_TRIGGER_DEFINITIONS = [
  {
    id: "inspector_daily_summary",
    label: "Daily inspector progress summary (8am, Tue–Sat)",
    group: "Inspector Reports",
    hardcodedTemplate: true,
  },
  {
    id: "inspector_weekly_summary",
    label: "Weekly inspector progress summary (Saturday 8am)",
    group: "Inspector Reports",
    hardcodedTemplate: true,
  },
];
